import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import pt from './pt'

Vue.use(VueI18n)

const savedLang = localStorage.getItem('lang') || 'zh'

const i18n = new VueI18n({
  locale: savedLang,
  fallbackLocale: 'zh',
  messages: { zh, pt }
})

export default i18n
